export default function searchUrl(keyword) {
  return `/search/${keyword}`
}
